var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3d3e0e07f76e940ba2846aa23896aa6e.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b36b7f12f1576db293e3e44f02a886a3.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    